'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Navigation, Pagination } from 'swiper/modules';
import { BlogCard } from './blog-card';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const BlogsSwiper = ({ blogs }: { blogs: Blog[] }) => {
  return (
    <Swiper
      pagination={true}
      modules={[Pagination, Navigation]}
      className={cn('mySwiper', 'custom-container', 'ea-custom-swiper')}
      spaceBetween={16}
      slidesPerView={1.1}
      breakpoints={{
        1280: {
          slidesPerView: 2.2,
          spaceBetween: 32
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        }
      }}
    >
      {blogs.map(blog => (
        <SwiperSlide key={blog.slug} className="w-full">
          <BlogCard blog={blog} key={blog.slug} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
